import { ampli } from '@/ampli';
import type { ProductCategory } from '@/app/api/lib/products/product.types';

import { trackEvent } from './track';

/** Vocabulaire fermé de `nav_item`, fixé par le plan Amplitude. */
export type NavItem =
    | 'home_link'
    | 'logo'
    | 'destinations_menu'
    | 'destination_card'
    | 'zone_tab'
    | 'my_projects'
    | 'my_catalog'
    | 'cart'
    | 'user_menu'
    | 'locale_switcher'
    | 'currency_switcher'
    | 'category_tab'
    | 'dmc_link'
    | 'product_link';

/** Vocabulaire fermé de `trigger_context`, fixé par le plan Amplitude. */
export type NavTriggerContext =
    'navbar' | 'mobile_drawer' | 'destinations_mega_menu' | 'category_switcher' | 'page_content';

/**
 * Le plan ne renseigne `product_category` que pour un clic sur un onglet de catégorie : le type
 * l'impose là et l'interdit ailleurs.
 */
type NavigationClick =
    | {
          navItem: 'category_tab';
          triggerContext: 'category_switcher';
          productCategory: ProductCategory;
      }
    | { navItem: Exclude<NavItem, 'category_tab'>; triggerContext: NavTriggerContext };

export function trackNavigationClick(click: NavigationClick): void {
    trackEvent(() =>
        ampli.catalogNavigationClicked({
            nav_item: click.navItem,
            trigger_context: click.triggerContext,
            ...(click.navItem === 'category_tab'
                ? { product_category: click.productCategory }
                : {}),
        }),
    );
}
